import * as yup from 'yup';

export const formLoginValidator = yup.object().shape({
    email: yup
        .string()
        .email("E-mail inválido")
        .required("Campo obrigatório"),
    senha: yup
        .string()
        .required("Campo obrigatório")
})

export const formPrimeiroAcessoValidator = yup.object().shape({
    cnpj: yup
        .string()
        .required("Campo obrigatório")
})

export const mapearData = (values) => {
    let data = {
        email: values.email,
        senha: values.senha
    }

    return data;
}

export const formLoginInitialState = { email: '', senha: '' }